/*! Gartensauna Konfigurator – robuste Filter-Variante (c) 2025 */
(function(){
  const mount = document.getElementById('sauna-konfigurator');
  if (!mount) {
    console.warn('[Gartensauna-Konfigurator] Container #sauna-konfigurator nicht gefunden.');
    return;
  }

  // Akzentfarbe aus Theme ableiten
  function deriveAccent() {
    try {
      const btn = document.querySelector('button, .button, .btn, [type=submit]');
      if (btn) {
        const bg = getComputedStyle(btn).backgroundColor;
        if (bg && bg !== 'rgba(0, 0, 0, 0)' && bg !== 'transparent') return bg;
        const col = getComputedStyle(btn).color;
        if (col) return col;
      }
      const a = document.createElement('a');
      a.style.display = 'none';
      document.body.appendChild(a);
      const col = getComputedStyle(a).color;
      a.remove();
      return col || '#0046ff';
    } catch(e) {
      return '#0046ff';
    }
  }

  const ACCENT = deriveAccent();

  // ---------- CSS ----------
  const css = `
  .ssk *{box-sizing:border-box}
  .ssk{font-family:inherit;color:inherit;background:transparent}
  .ssk .wrap{max-width:980px;margin:0 auto;padding:16px}
  .ssk .hd{text-align:center;margin-bottom:8px}
  .ssk .hd h2{font-size:1.35rem;margin:0 0 4px;font-weight:700}
  .ssk .hd p{font-size:.95rem;color:rgba(0,0,0,.65);margin:0}
  .ssk .pb{height:3px;background:rgba(0,0,0,.08);border-radius:3px;margin:10px auto 14px;overflow:hidden;max-width:420px}
  .ssk .pf{height:100%;width:0;background:${ACCENT};transition:width .25s ease;border-radius:3px}
  .ssk .pt{text-align:center;margin:0 0 12px;font-size:.85rem;color:rgba(0,0,0,.55)}
  .ssk .card{background:rgba(0,0,0,.02);border:1px solid rgba(0,0,0,.06);border-radius:4px;padding:14px}
  .ssk .step{display:none}
  .ssk .step.active{display:block}
  .ssk h3{text-align:center;font-size:1.06rem;margin:2px 0 10px}
  .ssk .opts{display:grid;grid-template-columns:repeat(auto-fit,minmax(140px,1fr));gap:10px;margin-bottom:8px}
  .ssk .opt{border:1px solid rgba(0,0,0,.16);background:#fff;border-radius:4px;padding:10px;text-align:center;cursor:pointer;transition:transform .1s ease,border-color .12s ease, background-color .12s ease}
  .ssk .opt:hover{border-color:${ACCENT};background:rgba(0,0,0,.02);transform:translateY(-1px)}
  .ssk .opt.sel{border-color:${ACCENT};background:rgba(0,0,0,.02)}
  .ssk .opt .lbl{font-weight:700;margin-bottom:4px}
  .ssk .opt .sub{font-size:.8rem;color:rgba(0,0,0,.6)}
  .ssk .nav{display:flex;gap:8px;max-width:400px;margin:8px auto 0}
  .ssk .btn{flex:1;padding:8px 12px;border-radius:3px;border:1px solid rgba(0,0,0,.2);background:#fff;font-weight:700;cursor:pointer;font-size:.95rem}
  .ssk .btn:hover{border-color:${ACCENT};background:rgba(0,0,0,.02)}
  .ssk .btn[disabled]{opacity:.45;cursor:not-allowed}
  .ssk .res{display:none;background:rgba(0,0,0,.02);border:1px solid rgba(0,0,0,.06);border-radius:4px;padding:16px;margin-top:10px}
  .ssk .res.show{display:block}
  .ssk .sum{background:#fff;border:1px solid rgba(0,0,0,.08);border-radius:4px;padding:10px;max-width:520px;margin:0 auto 14px}
  .ssk .sum .row{display:flex;justify-content:space-between;border-bottom:1px dashed rgba(0,0,0,.08);padding:6px 0}
  .ssk .sum .row:last-child{border-bottom:0}
  .ssk .sum .k{font-weight:600;color:rgba(0,0,0,.6)}
  .ssk .sum .v{font-weight:800;color:${ACCENT}}
  .ssk .grid-msg{text-align:center;font-size:.95rem;margin:6px 0 10px}
  .ssk .consult{margin-top:16px;background:rgba(0,0,0,.02);padding:14px;border-radius:4px;border:1px solid rgba(0,0,0,.06);text-align:center}
  .ssk .consult h3{margin:0 0 6px}
  .ssk .consult p{margin:0 0 10px}
  .ssk .lnk{display:inline-block;background:${ACCENT};color:#fff;padding:9px 14px;border-radius:3px;text-decoration:none;font-weight:800}
  .ssk .lnk:hover{opacity:.9}
  `;

  // ---------- HTML ----------
  const html = `
  <div class="ssk">
    <div class="wrap">

      <div class="hd">
        <h2>Gartensauna-Konfigurator</h2>
        <p>In 3 kurzen Schritten zu Ihrer passenden Gartensauna</p>
      </div>

      <div class="pb"><div class="pf" id="ssk_pf"></div></div>
      <div class="pt" id="ssk_pt">Schritt 1 von 3</div>

      <div class="card" id="ssk_card">

        <!-- Schritt 1: Personenanzahl -->
        <div class="step active" data-step="1">
          <h3>Für wie viele Personen planen Sie Ihre Gartensauna?</h3>
          <div class="opts">
            <div class="opt" data-filter="persons" data-value="2 Personen"><div class="lbl">2 Personen</div></div>
            <div class="opt" data-filter="persons" data-value="4 Personen"><div class="lbl">4 Personen</div></div>
            <div class="opt" data-filter="persons" data-value="6 Personen"><div class="lbl">6 Personen</div></div>
            <div class="opt" data-filter="persons" data-value="8 Personen"><div class="lbl">8 Personen</div></div>
            <div class="opt" data-filter="persons" data-value="10 Personen"><div class="lbl">10 Personen</div></div>
          </div>
          <div class="nav"><button class="btn next" id="ssk_n1" disabled>Weiter →</button></div>
        </div>

        <!-- Schritt 2: Saunaform -->
        <div class="step" data-step="2">
          <h3>Welche Saunaform passt am besten in Ihren Garten?</h3>
          <div class="opts">
            <div class="opt" data-filter="shape" data-value="Fasssauna">
              <div class="lbl">Fasssauna</div>
              <div class="sub">Klassische, runde Form – sehr beliebt</div>
            </div>
            <div class="opt" data-filter="shape" data-value="Cube Sauna / quadratische Sauna">
              <div class="lbl">Cube Sauna</div>
              <div class="sub">Moderne, kubische Form</div>
            </div>
            <div class="opt" data-filter="shape" data-value="Ovale Sauna">
              <div class="lbl">Ovale Sauna</div>
              <div class="sub">Weiche, harmonische Form</div>
            </div>
            <div class="opt" data-filter="shape" data-value="Blockbohlensauna">
              <div class="lbl">Blockbohlensauna</div>
              <div class="sub">Massive Blockbohlen-Bauweise</div>
            </div>
            <div class="opt" data-filter="shape" data-value="Saunahaus">
              <div class="lbl">Saunahaus</div>
              <div class="sub">Saunahaus mit klassischer Optik</div>
            </div>
          </div>
          <div class="nav">
            <button class="btn" id="ssk_b2">← Zurück</button>
            <button class="btn next" id="ssk_n2" disabled>Weiter →</button>
          </div>
        </div>

        <!-- Schritt 3: Heizart -->
        <div class="step" data-step="3">
          <h3>Wie möchten Sie Ihre Gartensauna heizen?</h3>
          <div class="opts">
            <div class="opt" data-filter="heater" data-value="Holzofen">
              <div class="lbl">Holzofen</div>
              <div class="sub">Klassisches Saunaerlebnis mit Holzfeuer</div>
            </div>
            <div class="opt" data-filter="heater" data-value="Elektroofen">
              <div class="lbl">Elektroofen</div>
              <div class="sub">Komfortabel, schnell & steuerbar</div>
            </div>
            <div class="opt" data-filter="heater" data-value="Holzofen und Elektroofen möglich">
              <div class="lbl">Holzofen & Elektroofen möglich</div>
              <div class="sub">Maximale Flexibilität bei der Beheizung</div>
            </div>
          </div>
          <div class="nav"><button class="btn" id="ssk_b3">← Zurück</button></div>
        </div>

      </div>

      <!-- Ergebnisbereich -->
      <div class="res" id="ssk_res">
        <h2>Ihre persönliche Gartensauna-Auswahl</h2>

        <div class="sum">
          <div class="row"><span class="k">Personen:</span><span class="v" id="ssk_sumP">-</span></div>
          <div class="row"><span class="k">Saunaform:</span><span class="v" id="ssk_sumS">-</span></div>
          <div class="row"><span class="k">Heizart:</span><span class="v" id="ssk_sumH">-</span></div>
        </div>

        <div id="ssk_grid"></div>

        <div class="consult">
          <h3>Persönliche Gartensauna-Beratung?</h3>
          <p>Gerne bespreche ich mit Ihnen Ihre perfekte Gartensauna – unverbindlich & persönlich.</p>
          <a class="lnk" href="https://calendly.com/jens-ischebeck/gartensauna-beratung" target="_blank" rel="noopener noreferrer">
            Beratungstermin buchen →
          </a>
        </div>
      </div>

    </div>
  </div>
  `;

  // In DOM einfügen
  const style = document.createElement('style');
  style.textContent = css;
  mount.innerHTML = html;
  mount.prepend(style);

  // ---------- State & Helfer ----------
  let step = 1;
  const total = 3;
  const cfg = { persons: null, shape: null, heater: null };

  const $  = s => mount.querySelector(s);
  const $$ = s => mount.querySelectorAll(s);

  function updateProgress() {
    $('#ssk_pf').style.width = (step / total * 100) + '%';
    $('#ssk_pt').textContent = `Schritt ${step} von ${total}`;
  }
  updateProgress();

  function showStep(n) {
    $$('.step').forEach(el => el.classList.remove('active'));
    const target = mount.querySelector(`.step[data-step="${n}"]`);
    if (target) target.classList.add('active');
    step = n;
    updateProgress();
  }

  // Checkbox-Name/Value anhand des Label-Textes im bestehenden Filter finden
  function getFilterParamByLabel(labelText) {
    if (!labelText) return null;
    labelText = labelText.trim();

    // alle Labels im Dokument durchsuchen
    const labels = Array.from(document.querySelectorAll('label'));
    for (const label of labels) {
      const txt = label.textContent.replace(/\s+/g, ' ').trim();
      // Shopify hängt häufig die Trefferanzahl in Klammern an („4 Personen (3)“)
      if (txt.startsWith(labelText)) {
        let input = label.querySelector('input[type="checkbox"], input[type="radio"]');
        // Falls das Input nicht im Label steckt, sondern über "for" verknüpft ist
        if (!input && label.htmlFor) {
          input = document.getElementById(label.htmlFor);
        }
        if (input && input.name && typeof input.value === 'string') {
          return { name: input.name, value: input.value };
        }
      }
    }
    return null;
  }

  function buildURLFromConfig() {
    const url = new URL(window.location.href);
    const params = url.searchParams;

    // vorhandene Filter zurücksetzen
    Array.from(params.keys()).forEach(key => {
      if (key.startsWith('filter.')) params.delete(key);
    });

    // Personenanzahl
    const p = getFilterParamByLabel(cfg.persons);
    if (p) params.set(p.name, p.value);

    // Saunaform
    const s = getFilterParamByLabel(cfg.shape);
    if (s) params.set(s.name, s.value);

    // Heizart
    // Sonderlogik: "Holzofen" soll den Filter "Holzofen und Elektroofen möglich" setzen
    let h = null;
    if (cfg.heater === 'Holzofen') {
      h = getFilterParamByLabel('Holzofen und Elektroofen möglich');
    } else {
      h = getFilterParamByLabel(cfg.heater);
    }
    if (h) {
      params.set(h.name, h.value);
    }

    url.search = params.toString();
    return url.toString();
  }

  // ---------- Events ----------
  mount.addEventListener('click', ev => {
    const opt = ev.target.closest('.opt');
    if (opt) {
      const f = opt.getAttribute('data-filter');
      const v = opt.getAttribute('data-value');

      $$('.opt[data-filter="'+f+'"]').forEach(o => o.classList.remove('sel'));
      opt.classList.add('sel');

      cfg[f] = v;

      const st = opt.closest('.step').getAttribute('data-step');
      const nextBtn = $('#ssk_n' + st);
      if (nextBtn) nextBtn.disabled = false;

      setTimeout(() => {
        if (st === '3') {
          showResults();
        } else if (nextBtn) {
          nextBtn.click();
        }
      }, 150);
    }

    if (ev.target.id === 'ssk_n1') showStep(2);
    if (ev.target.id === 'ssk_b2') showStep(1);
    if (ev.target.id === 'ssk_n2') showStep(3);
    if (ev.target.id === 'ssk_b3') showStep(2);
  });

  // ---------- Ergebnisse anzeigen ----------
  function showResults() {
    $('#ssk_sumP').textContent = cfg.persons || '-';
    $('#ssk_sumS').textContent = cfg.shape   || '-';
    $('#ssk_sumH').textContent = cfg.heater  || '-';

    $('#ssk_card').style.display = 'none';
    const pb = mount.querySelector('.pb');
    const pt = mount.querySelector('.pt');
    if (pb) pb.style.display = 'none';
    if (pt) pt.style.display = 'none';

    const url = buildURLFromConfig();

    $('#ssk_grid').innerHTML = `
      <p class="grid-msg">
        Auf der folgenden Seite sehen Sie alle Gartensaunen, die zu Ihrer Auswahl passen:
      </p>
      <a class="lnk" href="${url}">Zu Ihrer Gartensauna-Auswahl →</a>
    `;

    $('#ssk_res').classList.add('show');
  }

})();
